import AnnouncementShowPage from '../../components/pages/announcements/AnnouncementShowPage.vue'
export default {
  components: { AnnouncementShowPage }
}
